module.exports = __webpack_public_path__ + "static/img/baoming2.e3bb5a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/baoming2.png
// module id = nQCG
// module chunks = 0